import { render, staticRenderFns } from "./DeleteProductBtn.vue?vue&type=template&id=9b523d3a&scoped=true"
import script from "./DeleteProductBtn.vue?vue&type=script&lang=js"
export * from "./DeleteProductBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b523d3a",
  null
  
)

export default component.exports